import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamFRFR() {
  return (
    <div className={styles["declaration"]}>
      <h1>Déclaration de conformité pour la formation et l'examen des membres de la force opérationnelle</h1>

      <p>
        Pour améliorer continuellement la qualité du service des promoteurs tiers en première ligne, l'équipe de formation du département international de Xiaomi (ci-après dénommée « nous » ou « notre entreprise ») propose des cours de formation et des examens de renforcement des connaissances pour les promoteurs tiers (ci-après dénommés « stagiaires ») désignés par les prestataires de services externes. L'objectif de la formation et de l'examen est d'optimiser le contenu des cours et de consolider les résultats d'apprentissage, et ne constitue aucune forme de relation de travail ou de comportement de gestion effective. Voici la déclaration concernant la formation et l'examen :
      </p>

      <ol>
        <li>
          <strong>Nature de la formation et de l'examen</strong><br/>
          Tous les cours de formation et les examens sont menés dans le but de partager des connaissances, visant à aider les stagiaires à comprendre systématiquement les informations sur les produits et les normes de service, etc. Les résultats des examens reflètent uniquement la compréhension des stagiaires concernant le contenu de la formation et ne doivent pas servir de base pour l'évaluation des performances ; nous n'avons aucune autorité et n'interférerons pas avec les évaluations des performances, la distribution des salaires ou d'autres questions relatives aux relations de travail des stagiaires par les prestataires de services externes.
        </li>
        <li>
          <strong>Clarification de la relation juridique</strong><br/>
          La relation employeur-employé entre les stagiaires et leurs prestataires de services externes respectifs reste inchangée par ce programme de formation et d'examen. Il n'existe aucune relation employeur-employé entre notre entreprise et les stagiaires, ce programme de formation et d'examen pour le partage des connaissances n'établissant nullement une relation de travail effective avec les stagiaires.
        </li>
        <li>
          <strong>Utilisation des résultats des examens</strong><br/>
          Les résultats des examens ne doivent être utilisés qu'aux fins suivantes :
          <ol type="1">
            <li>Servir de référence pour l'optimisation et l'amélioration internes des cours de notre entreprise ;</li>
            <li>Être fournis aux prestataires de services externes comme preuve de la compétence professionnelle des stagiaires, sous réserve du jugement indépendant et de la volonté des prestataires de services externes ;</li>
            <li>Les résultats des examens ne seront pas rendus publics ou divulgués à des tiers.</li>
          </ol>
        </li>
      </ol>

      <p>
        Cette déclaration entrera en vigueur à partir de la date de publication. La participation au programme de formation et d'examen constitue la reconnaissance et l'acceptation de cette déclaration par les stagiaires. Notre entreprise se réserve le droit final d'interprétation et de modification raisonnable de cette déclaration.
      </p>

      <div className={styles["footer"]}>
        Équipe de Formation du Département International de Xiaomi<br/>
        Date : {getLocalizedTime('fr-FR')}
      </div>
    </div>
  );
}